import React, { Component } from 'react';
import NotificationSystem from 'react-notification-system';
import ReCAPTCHA from 'react-google-recaptcha';
import axios from 'axios';
import { Link, Router } from 'react-router-dom'
import './App.css';

class App extends Component {
  constructor() {
    super();
    this.state = {
      'address': '',
      tokenvalue: "",
      errors: "",
      'recaptcha': '',
    };
    this.notificationSystem = null;

    this.addNotification = this.addNotification.bind(this);
    this.handleCaptchaResponse = this.handleCaptchaResponse.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    this.notificationSystem = this.refs.notificationSystem;
  }

  addNotification(type, response) {
    let action;
    if (type === 'success') {
      action = {
        label: 'View Transaction',
        callback: function () {
          window.open('https://explorer.apothem.network/txs/' + response);
        }
      }
    }
    switch (type) {
      case 'success':
        this.notificationSystem.addNotification({
          message: 'Transaction Successful!',
          level: type,
          position: 'bc',
          action: action
        });
        break;
      case 'error':
        if (response === 'IP address temporarily blacklisted.') {
          this.notificationSystem.addNotification({
            message: "We only drip maximum 200 PLI per user per day, please try again tomorrow.",
            level: type,
            position: 'bc'
          });
        }
        // else if (response === 'Invalid Recaptcha.') {
        //   this.notificationSystem.addNotification({
        //     message: "Invalid recaptcha response, try again.",
        //     level: type,
        //     position: 'bc'
        //   });
        // } 
        else if (response === 'Empty address field.') {
          this.notificationSystem.addNotification({
            message: "Address field cannot be empty.",
            level: type,
            position: 'bc'
          })
        } else {
          this.notificationSystem.addNotification({
            message: 'Transaction Unsuccessful!',
            level: type,
            position: 'bc'
          });
        }
        break;
      default:
        break;
    }
  }

  handleChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  async handleSubmit(e) {
    e.preventDefault();
    this.setState({
      errors: ""
    })
    if (this.state.address === "" || this.state.tokenvalue === "" || this.state.recaptcha === "") {
      this.setState({
        errors: "Fill all the fields"
      })
      return;
    }

    // window.grecaptcha.reset();
    let address = this.state.address;
    let tokenvalue = this.state.tokenvalue;
    let recaptcha = this.state.recaptcha;
    const url = 'https://faucet.plugin.global/api/eth_sendRawTransaction';

    let type = '';
    let response;
    let txHash = '';
    let post_error = false;

    try {
      response = await axios({
        method: 'POST',
        url: url,
        headers: {
          'Content-Type': 'application/json'
        },
        data: JSON.stringify({
          'address': address,
          'tokenvalue': tokenvalue,
          'g-recaptcha-response': recaptcha
        })
      })
    } catch (e) {
      post_error = true;
      type = 'error';
      txHash = e.response.data;
    }

    if (!post_error) {
      if (response['data']) {
        type = 'success';
        txHash = response.data;
      }
    }

    this.addNotification(type, txHash);

    this.setState({ 'address': '' });
  }

  handleCaptchaResponse(response) {
    this.setState({ 'recaptcha': response })
  }
  onChangePLI(value) {
    this.setState({
      tokenvalue: value
    })
  }

  render() {
    console.log("this.state", this.state)
    return (
      <div>

        <div className="container">
          <div className="row">
            <div className="col-12 col-md-6">
              <div className=" d-flex justify-content-between align-self-center align-items-center">
                <div>
                  <img src="/img/signature-pli-circle@1x.png" width="80%" />
                </div>
                <div>
                  <img src="/img/plugin-white@1x.png" width="80%" />
                </div>
              </div>
              <div className="row mt-3 plugin-aphotem">
                <div class="title d-flex justify-content-center align-items-center ">
                  <div class="text-1 mx-2">
                    <span class="span0">PLUGIN'S PLI</span><span>&nbsp;</span><span class="span2">|</span><span> APOTHEM FAUCET</span>
                  </div>
                </div>
              </div>
              <div className="row padding-bottom mt-2">
                <div className="text-2">Instantly Get Apothem PLI to<br />Experiment On Test Net (Apothem)</div>
              </div>
              <div className="row  d-flex justify-content-between align-items-center">
                <div className="col-4">
                  <img src="/img/icon-community@1x.png" width="100px" height="100px" />
                </div>
                <div className="col-4">
                  <img src="/img/icon-instant@1x.png" width="78px" height="100px" />
                </div>
                <div className="col-4">
                  <img src="/img/incon-pig@1x.png" width="78px" height="100px" />
                </div>
              </div>
              <div className="row mt-4">
                <form onSubmit={this.handleSubmit} style={{ width: "100%" }}>
                  <div className="input-group">
                    <input type="text" style={{ width: "65%", marginRight: "8px", borderRadius: 50 }} className="form-control fwd-input" placeholder="Your XDC Address" name="address" value={this.state.address} onChange={this.handleChange} aria-label="Text input with dropdown button" />
                    <div className="input-group-append">
                      <select name="tokenvalue" value={this.state.tokenvalue} onChange={this.handleChange} style={{ borderRadius: 50, marginLeft: 10 }} class="form-control form-control-lg" id="sel1">
                        <option>Give Me PLI</option>
                        <option value="200">200 PLI/1 hour</option>
                        {/* <option value="3">3 PLI/1 hour</option>
                        <option value="5">5 PLI/1 hour</option>
                        <option value="10">10 PLI/1 hour</option> */}
                      </select>

                    </div>
                  </div>
                  <div className="my-2" />
                  <ReCAPTCHA sitekey="6LdVQmccAAAAAIgcSO3niBx0zuN18BXpjX-GLhgN" onChange={this.handleCaptchaResponse} />
                  <div class="my-2 text-danger text-center">{this.state.errors}</div>
                  <button type="submit" style={{ backgroundColor: "#ffbe00", borderColor: "#E8843F", height: 60, width: 250, borderRadius: 50, borderWidth: 5 }} class="btn btn-primary btn-block mt-2"><span style={{ color: "#E8843F", fontSize: 20 }}>Get PLI Now</span></button>
                </form>
                <br />
                <small className="my-3 text-3"> Add this smart contract address in <code style={{ color: "#ffbe00" }}>0x33f4212b027e22af7e6ba21fc572843c0d701cd1</code> custom token to see your PLI token in Apothem.</small>
                <NotificationSystem ref="notificationSystem" />
              </div>
              <div className="row d-flex justify-content-between align-items-center">
                <div className="col col-md-6 col-lg-6">
                  <div className="row" style={{ paddingTop: "20px", paddingBottom: "20px" }}>
                    <div className="col text-4">
                      JOIN PLUGIN COMMUNITY TO GET MORE UPDATES
                    </div>
                  </div>
                </div>
                <div className="col col-md-6 col-lg-6 ">
                  <a className="text-white" href="https://t.me/goplugin" target="_blank">
                    <img src="/img/icon-telegram@1x.png" width="32" height="32" />
                  </a>  <a className="text-white" href="https://twitter.com/goplugin" target="_blank"><img src="/img/icon-twitter@1x.png" width="32" height="32" /></a>  <a className="text-white" href="https://discord.gg/4ATypYHudd" target="_blank"><img src="/img/icon-discord@1x.png" width="32" height="32" /></a>  <a className="text-white" href="https://facebook.com/PluginPLI" target="_blank"><img src="/img/icon-facebook@1x.png" width="32" height="32" /></a>
                </div>
              </div>
            </div>

          </div>

        </div>

      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js